var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrofonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 61,
    viewBox: "0 0 47 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.0009 21.4725C42.8523 21.4725 41.9393 22.4075 41.9393 23.5838V28.3494C41.9393 39.0266 33.4572 47.713 23.0313 47.713C12.6053 47.713 4.12324 39.0266 4.12324 28.3494V23.5537C4.12324 22.3774 3.21024 21.4424 2.06162 21.4424C0.913005 21.4424 0 22.3774 0 23.5537V28.3192C0 40.5949 9.21839 50.699 20.9697 51.7848V58.2092C20.9697 59.3855 21.8827 60.3205 23.0313 60.3205C24.1799 60.3205 25.0929 59.3855 25.0929 58.2092V51.7848C36.8147 50.7292 46.0626 40.5949 46.0626 28.3192V23.5537C46.0331 22.4075 45.1201 21.4725 44.0009 21.4725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.0266 0C15.8405 0 10.009 5.97196 10.009 13.3313V28.774C10.009 36.1334 15.8405 42.1053 23.0266 42.1053C30.2129 42.1053 36.0443 36.1334 36.0443 28.774V13.3313C36.0443 5.97196 30.2129 0 23.0266 0ZM26.8848 20.9622C26.6787 21.7464 26.0013 22.2591 25.2355 22.2591C25.0883 22.2591 24.941 22.229 24.7937 22.1988C23.6451 21.867 22.4376 21.867 21.289 22.1988C20.3465 22.4703 19.4335 21.8972 19.1979 20.9622C18.9329 20.0272 19.4924 19.062 20.4054 18.8207C22.1431 18.3381 23.9691 18.3381 25.7068 18.8207C26.5903 19.062 27.1204 20.0272 26.8848 20.9622ZM28.4458 15.1109C28.1807 15.8347 27.5328 16.257 26.8259 16.257C26.6198 16.257 26.443 16.2268 26.2369 16.1665C24.1753 15.3823 21.878 15.3823 19.8164 16.1665C18.9329 16.4983 17.9315 16.0157 17.6075 15.1109C17.2836 14.206 17.7548 13.1805 18.6383 12.8789C21.4657 11.8233 24.5876 11.8233 27.415 12.8789C28.2985 13.2107 28.7697 14.206 28.4458 15.1109Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrofonWhite);
export default __webpack_public_path__ + "static/media/microfon-white.c5e9af9061225beddbe48bfe7ddc8e11.svg";
export { ForwardRef as ReactComponent };